export enum WeatherBroadcast {
    SelectionUpdated = "selection-updated"
}